"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Enums_1 = require("../Enums");
var HighlightProprietaire_1 = __importDefault(require("../Mixins/HighlightProprietaire"));
exports.default = {
    name: 'CopieProprietaire',
    props: {
        value: {
            type: Object
        },
        referencedProprietaire: {
            type: Object
        }
    },
    mixins: [HighlightProprietaire_1.default],
    data: function () {
        return {
            optionsTypePropriete: Object.keys(Enums_1.TypeDroitProprieteEnum).map(function (_) { return Enums_1.TypeDroitProprieteEnum[_]; }),
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/ConventionServitude/Components/CopieProprietaire.vue
// module id = 238
// module chunks = 0